import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { messagingQueryKeys } from '@/modules/messaging/queries/queryKeys';

/**
 * Puts failed messages back in the send queue. `/messages/send` marks them
 * Pending for the background worker, which is what a resend means here.
 */
export const useResendMessagesMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (messageIds: string[]) => {
      await fetchClient.PUT('/messages/send', { body: { messageIds } });
    },
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: messagingQueryKeys.threads() }),
  });
};
